module.exports = __webpack_public_path__ + "img/orange-spirit-mark.43f38f93.png";